import { Form, Input } from "decorator-form";

import InputType from "common/form/InputType";

@Form({title: "Progress Circle Config"})
export default class ProgressCircleViewConfig {

	@Input({type: InputType.COLOR, title: "Value Color"})
	public valueColor: string = "#d3d3d3";

	@Input({type: InputType.COLOR, title: "Background Color"})
	public backgroundColor: string = "#f3f3f3";

	@Input({type: InputType.NUMBER, title: "Size"})
	public size: number = 75;

	@Input({type: InputType.NUMBER, title: "Stroke Width"})
	public strokeWidth: number = 8;

	@Input({type: InputType.CHECKBOX, title: "Show Checkmark When 100%"})
	public showCheckmark: boolean;

	@Input({type: InputType.COLOR, title: "Checkmark Color"})
	public checkmarkColor: string = "#fff";

}



// WEBPACK FOOTER //
// ./src/common/views/progressCircle/ProgressCircleViewConfig.ts